export default __webpack_public_path__ + "static/numpad-in-progress-63fc8a66c030d1d3c2f8d848f45f7bb8.jpeg";